(() => {
  const headingSelector = 'h1, h2, h3, h4, h5, h6';

  const normalizeText = (value) => value.replace(/\s+/g, ' ').trim().toLocaleLowerCase();

  const removeDuplicateHeading = (content, title) => {
    if (!content || !title) return;

    const firstHeading = content.querySelector(headingSelector);
    if (!firstHeading) return;

    if (normalizeText(firstHeading.textContent) === normalizeText(title.textContent)) {
      firstHeading.remove();
    }
  };

  const initializeCmsContent = () => {
    document.querySelectorAll('.shopify-policy__container').forEach((container) => {
      removeDuplicateHeading(
        container.querySelector('.shopify-policy__body'),
        container.querySelector('.shopify-policy__title')
      );
    });

    document.querySelectorAll('.page__content.page-copy').forEach((content) => {
      const section = content.closest('.shopify-section');
      removeDuplicateHeading(content, section?.querySelector('.page__title'));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCmsContent, { once: true });
  } else {
    initializeCmsContent();
  }

  document.addEventListener('shopify:section:load', initializeCmsContent);
})();
